import type { Theme } from "@emotion/react";
import { css } from "@emotion/react";

export const orSection = (theme: Theme) => css`
  margin: 1rem 0;
  color: ${theme.system.textBase};
  overflow: hidden;
  text-transform: uppercase;
  width: 100%;

  &:before,
  &:after {
    background-color: ${theme.system.backgroundMutedActive};
    content: "";
    display: inline-block;
    height: 1px;
    position: relative;
    vertical-align: middle;
    width: 50%;
  }

  &:before {
    right: 0.5rem;
    margin-left: -50%;
  }

  &:after {
    left: 0.5rem;
    margin-right: -50%;
  }
`;

export const fullWidthButton = css`
  width: 100%;
  display: block;

  form {
    width: 100%;
    display: block;
  }

  form > label {
    width: 100%;
    display: flex;
  }
`;

export const rowWrapper = css`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;

  & > div {
    flex: 1;
    min-width: 250px;
  }
`;
